import './loader.scss'

const Loader = () => {
  return (
    <section className='loader' />
  )
}

export default Loader
